<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">Requisition Activity</h4>
</div>

<div class="modal-body">
    <div class="row">
        <div class="col-xs-12" style="padding:15px;">
            Activity details for requisition <span class="emerald">{{modalData.role}}</span> with requisition number
            <span class="emerald">{{modalData.requisitionNumber}}</span> for <span class="emerald">{{modalData.clientName}}</span>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12">
            <app-requisition-activity [jobId]="modalData.jobId" [isSharedRequisition]="modalData.isSharedRequisition"></app-requisition-activity>
        </div>
    </div>
</div>
